import React from "react";

// View git history to see old endpoints that were hit for each form.

const FormActionButton = () => <div>Old forms cannot be used.</div>;

export default FormActionButton;
